<template>
  <v-navigation-drawer
    v-model="drawer"
    :clipped="clipped"
    color="gry"
    app
    dark
    enable-resize-watcher
    mobile-break-point="991"
  >
    <v-list
      dense
      nav
      class="py-0">
      <v-list-item>
        <img
          src="../../assets/img/logo-invers.png"
          style="max-width:100%; height:auto;padding-top:10px;"
        >
      </v-list-item>

      <v-divider />

      <v-list-item
        v-for="item in links"
        :key="item.title"
        :to="item.path"
        link>
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="rid"
        to="/cabinet"
        link>
        <v-list-item-icon>
          <v-icon>mdi-account-multiple</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Cabinet</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        href="https://dentpedia.ro/feedback-app"
        target="_blank"
        link>
        <v-list-item-icon>
          <v-icon>mdi-comment-multiple</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Feedback</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  data () {
    return {
      clipped: false,
      links: [
        { title: 'Dashboard', path: '/', icon: 'mdi-view-dashboard' },
        { title: 'Programari', path: '/programari', icon: 'mdi-clock-outline' },
        { title: 'Pacienti', path: '/pacienti', icon: 'mdi-account-multiple' }
      ],
      color: 'primary',
      colors: ['primary', 'blue', 'success', 'red', 'teal'],
      right: true,
      miniVariant: false,
      expandOnHover: false,
      background: false
    }
  },
  computed: {
    bg () {
      return this.background
        ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg'
        : undefined
    },
    rid () {
      if (window.localStorage.loggedIn) {
        return this.$store.state.Profil.rid[0]
      } else {
        return false
      }
    },
    drawer: {
      get () {
        return this.$store.state.App.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    }
  },
  mounted () {
    if (window.localStorage.loggedIn) {
      this.loadRid()
    }
  },
  methods: {
    ...mapActions('Profil', ['loadRid']),
    ...mapMutations('App', ['setDrawer', 'toggleDrawer'])
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/core/Navbar.vue